// Physical dimensions in millimetres; independent of screen pixels and PNG DPI.
export const LABEL_WIDTH = 38;
export const LABEL_HEIGHT = 54;
export const A4_WIDTH = 210;
export const A4_HEIGHT = 297;
export const SHEET_MARGIN = 15;
export const LABEL_GAP = 5;
export const COLUMNS = Math.floor(
    (A4_WIDTH - SHEET_MARGIN * 2 + LABEL_GAP) / (LABEL_WIDTH + LABEL_GAP)
);
export const ROWS = Math.floor(
    (A4_HEIGHT - SHEET_MARGIN * 2 + LABEL_GAP) / (LABEL_HEIGHT + LABEL_GAP)
);
export const LABELS_PER_PAGE = COLUMNS * ROWS;

export function labelPosition(index: number) {
    return {
        left: SHEET_MARGIN + (index % COLUMNS) * (LABEL_WIDTH + LABEL_GAP),
        top: SHEET_MARGIN + Math.floor(index / COLUMNS) * (LABEL_HEIGHT + LABEL_GAP),
    };
}
